import { render, staticRenderFns } from "./QuestionUploadFile.vue?vue&type=template&id=9dcf4eaa&scoped=true&"
import script from "./QuestionUploadFile.vue?vue&type=script&lang=js&"
export * from "./QuestionUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./QuestionUploadFile.vue?vue&type=style&index=0&id=9dcf4eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf4eaa",
  null
  
)

export default component.exports